import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { useLayout } from '@vimeo/clip-ui/hooks/use-layout';
import { getSearchParams } from '@vimeo/viewer-showcase-ui/utils/helper';

// Ensure that the side module is closed when the user navigates to the gallery view
// This is necessary because the side module is not closed when the user navigates to the gallery view via the browser navigation
export const useSyncLayoutState = () => {
  const router = useRouter();
  const searchParams = getSearchParams();
  const clipId = searchParams.get('video');
  const { isSideModuleOpen, onClose } = useLayout();

  useEffect(() => {
    const handleBeforePopState = () => {
      if (clipId && isSideModuleOpen) {
        onClose?.();
      }
      return true;
    };

    router.beforePopState(handleBeforePopState);

    return () => {
      router.beforePopState(() => true);
    };
  }, [router, clipId, isSideModuleOpen, onClose]);
};
